import React from "react";
import PropTypes from "prop-types";
import {
  Banner as DefaultBanner,
  ButtonSecondary,
} from "../../../../components";
import backgroundImage from "../../../../assets/images/backgrounds/Banner_Desktop.png";
import backgroundImageMobile from "../../../../assets/images/backgrounds/Banner_Mobile.png";
import { links } from "../../../../config";
import BannerStyle from "./Banner.Style";

const Banner = ({
  home,
  contentWidth,
  descricao,
  smallerText,
  sectionName,
  bannerTitle,
  noBreadCrumbs,
  className,
  bottomText,
}) => {
  return (
    <BannerStyle
      as={DefaultBanner}
      smallerText={smallerText}
      sectionName={sectionName}
      variant="quaternary"
      backgroundImage={backgroundImage}
      backgroundImageMobile={backgroundImageMobile}
      contentWidth={{
        lg: 6.5,
        xl: 6.5,
        ...contentWidth,
      }}
      home={home}
      bannerTitle={bannerTitle}
      noBreadCrumbs={noBreadCrumbs}
      className={className}
      bottomText={bottomText}
      descricao={descricao}
    >
      {home ? (
        <ButtonSecondary
          href={links.habitacional.areaLogada}
          target="_blank"
          label="Acesse a área do cliente"
        />
      ) : null}
    </BannerStyle>
  );
};

Banner.defaultProps = {
  bottomText: null,
  home: false,
  contentWidth: null,
  descricao: null,
  smallerText: null,
  bannerTitle: null,
  noBreadCrumbs: false,
};

Banner.propTypes = {
  bottomText: PropTypes.string,
  home: PropTypes.bool,
  contentWidth: PropTypes.objectOf(
    PropTypes.shape({
      xs: PropTypes.number,
      sm: PropTypes.number,
      md: PropTypes.number,
      lg: PropTypes.number,
      xl: PropTypes.number,
    })
  ),
  descricao: PropTypes.element,
  smallerText: PropTypes.string,
  sectionName: PropTypes.string.isRequired,
  bannerTitle: PropTypes.string,
  noBreadCrumbs: PropTypes.bool,
};

export default Banner;
